
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RoleGuard from "./components/common/RoleGuard";
import PrivateRoute from './components/common/PrivateRoute';
import NotFound from './components/common/NotFound';
import LandingPage from './components/LandingPage/LandingPage';
import EmployeeDashboard from './components/Dashboard/DashboardNew';
import AttendancePortal from './components/Attendence/AttendancePortalNew';
import Login from './components/Login/LoginNew';
import ForgotPassword  from "./components/ForgotPassword/ForgotPasswordNew";
import ResetPassword from "./components/Reset_Password/ResetPasswordNew";

// Redesigned pages
import HolidaysList from './components/Holidays/HolidaysListNew';
import HolidayForm from './components/Holidays/HolidayFormNew';
import CreateEmployee from './components/Employee/CreateEmployeeNew';
import UserProfile from './components/Employee/UserProfileNew';
import EmployeeDetail from './components/Employee/EmployeeDetailNew';
import ReimbursementForm from './components/Reimbursment/ReimbursementFormNew';
import MyReimbursements from './components/Reimbursment/MyReimbursementsNew';
import ExpenseDashboard from "./components/Reimbursment/ExpenseDashboardNew";
import ReimbursementReport from "./components/Reimbursment/ReimbursementReportNew";
import AdminAttendanceLookup from './components/Attendence/AdminAttendanceLookupNew';
import AttendanceRegularization from "./components/Attendence/AttendanceRegularizationNew";
import ManagerAttendanceApprovals from "./components/Attendence/ManagerAttendanceApprovalsNew";
import ManagerFeedbackForm from './components/Performance/ManagerFeedbackFormNew';
import SelfAssessmentForm from './components/Performance/SelfAssessmentFormNew';
import timesheet from "./components/Timesheet/TimesheetFormNew";
import timesheetlist from "./components/Timesheet/TimesheetListNew";
import timesheetacess from "./components/Timesheet/TimesheetAccessNew";
import InventoryForm from './components/Inventory/InventoryFormNew';
import InventoryList from './components/Inventory/InventoryListNew';
import MyInventories from './components/Inventory/MyInventoriesNew';
import AssignInventoryToEmployee from "./components/Inventory/AssignInventoryToEmployeeNew";
import InventorySearch from './components/Inventory/InventoryDetailNew';
import SalarySlipForm from './components/SalarySlip/SalarySlipFormNew';
import CalendarView from './components/Calender/CalendarViewNew';
import SendMessage from './components/Messages/SendMessageNew';
import NotificationForm from './components/Notification/NotificationFormNew';

// Legacy (retained for now)
import EmployeeList from './components/Employee/EmployeeList';
import ArchivedEmployeeList from './components/Employee/ArchivedEmployeeList';
import ApplyForLeave from './components/Leave/ApplyForLeave';
import LeaveRequests from './components/Leave/LeaveRequests';
import GetMyAttendance from './components/Attendence/GetMyAttendanceNew';
import ReimbursementList from './components/Reimbursment/ReimbursementList';
import HolidaysListForEmployees from './components/Holidays/HolidaysListNew';
import MySalarySlip from './components/SalarySlip/MySalarySlip';
import ManagerList from './components/ManagerList/ManagerList';
import ManagerleaveRequest from './components/Leave/ManagerLeaveRequestsNew';
import contactdetail from './components/Employee/contactdetail';
import MyMessages from './components/Messages/MyMessagesNew';
import MySentMessages from './components/Messages/MySentMessagesNew';
import Whiteboard from './components/Whiteboard/Whiteboard';
import chatboard from './components/Chatboard/ChatBoard';
import groupchatboard from './components/Chatboard/Groupchat';
import VideoUpload from "./components/VideoUpload/VideoUpload";
import OvertimeRequest from "./components/Overtime/OvertimeRequest";
import ManagerOvertimeRequests from "./components/Overtime/ManagerOvertimeRequests";

// New modules (lazy-loaded for bundle size)
const PayrollConfigPage = React.lazy(() => import("./components/Payroll/PayrollConfig"));
const LoanManagement = React.lazy(() => import("./components/Payroll/LoanManagement"));
const PayrollRun = React.lazy(() => import("./components/Payroll/PayrollRun"));
const MyPayslips = React.lazy(() => import("./components/Payroll/MyPayslips"));
const OnboardingList = React.lazy(() => import("./components/Onboarding/OnboardingList"));
const OnboardingDetail = React.lazy(() => import("./components/Onboarding/OnboardingDetail"));
const OffboardingList = React.lazy(() => import("./components/Offboarding/OffboardingList"));
const OffboardingDetail = React.lazy(() => import("./components/Offboarding/OffboardingDetail"));
const ReportsDashboard = React.lazy(() => import("./components/Reports/ReportsDashboard"));
const LeaveTypesConfig = React.lazy(() => import("./components/Leave/LeaveTypesConfig"));
const JobsList = React.lazy(() => import("./components/Recruitment/JobsList"));
const CandidatePipeline = React.lazy(() => import("./components/Recruitment/CandidatePipeline"));
const JobDetail = React.lazy(() => import("./components/Recruitment/JobDetail"));
const AnnouncementsList = React.lazy(() => import("./components/Announcements/AnnouncementsList"));
const PoliciesList = React.lazy(() => import("./components/Policies/PoliciesList"));
const GoalsList = React.lazy(() => import("./components/Goals/GoalsList"));
const TeamDirectory = React.lazy(() => import("./components/SelfService/TeamDirectory"));
const OrgChart = React.lazy(() => import("./components/SelfService/OrgChart"));
const MyProfileEdit = React.lazy(() => import("./components/SelfService/MyProfileEdit"));
const DocumentVault = React.lazy(() => import("./components/SelfService/DocumentVault"));
const Letters = React.lazy(() => import("./components/SelfService/Letters"));
const InvestmentDeclaration = React.lazy(() => import("./components/Payroll/InvestmentDeclaration"));
const FlexibleBenefits = React.lazy(() => import("./components/Payroll/FlexibleBenefits"));
const BatchPayroll = React.lazy(() => import("./components/Payroll/BatchPayroll"));
const ShiftsConfig = React.lazy(() => import("./components/Attendence/ShiftsConfig"));
const GeoFencesConfig = React.lazy(() => import("./components/Attendence/GeoFencesConfig"));
const OfficeIpsConfig = React.lazy(() => import("./components/Attendence/OfficeIpsConfig"));
const TeamLeaveCalendar = React.lazy(() => import("./components/Attendence/TeamLeaveCalendar"));
const MyLeaveBalance = React.lazy(() => import("./components/Attendence/MyLeaveBalance"));
const KudosWall = React.lazy(() => import("./components/Performance/KudosWall"));
const CheckIns = React.lazy(() => import("./components/Performance/CheckIns"));
const NineBoxGrid = React.lazy(() => import("./components/Performance/NineBoxGrid"));
const PIPList = React.lazy(() => import("./components/Performance/PIPList"));
const ReviewCycles = React.lazy(() => import("./components/Performance/ReviewCycles"));
const CareerPage = React.lazy(() => import("./components/Careers/CareerPage"));
const OfferSignPage = React.lazy(() => import("./components/Careers/OfferSignPage"));
const Referrals = React.lazy(() => import("./components/Recruitment/Referrals"));
const TravelRequests = React.lazy(() => import("./components/Travel/TravelRequests"));
const TravelApprovals = React.lazy(() => import("./components/Travel/TravelApprovals"));
const SurveysList = React.lazy(() => import("./components/Engagement/SurveysList"));
const SurveyBuilder = React.lazy(() => import("./components/Engagement/SurveyBuilder"));
const TicketsList = React.lazy(() => import("./components/Helpdesk/TicketsList"));
const TicketDetail = React.lazy(() => import("./components/Helpdesk/TicketDetail"));
const KnowledgeBase = React.lazy(() => import("./components/Helpdesk/KnowledgeBase"));
const CustomReportBuilder = React.lazy(() => import("./components/Analytics/CustomReportBuilder"));
const AttritionRisk = React.lazy(() => import("./components/Analytics/AttritionRisk"));
const DEIDashboard = React.lazy(() => import("./components/Analytics/DEIDashboard"));
const WorkflowsList = React.lazy(() => import("./components/Workflows/WorkflowsList"));
const TwoFactorSetup = React.lazy(() => import("./components/Security/TwoFactorSetup"));
const SessionsList = React.lazy(() => import("./components/Security/SessionsList"));
const AuditLog = React.lazy(() => import("./components/Security/AuditLog"));
const SSOCallback = React.lazy(() => import("./components/SSO/SSOCallback"));
const IntegrationsList = React.lazy(() => import("./components/Integrations/IntegrationsList"));
const IntegrationStore = React.lazy(() => import("./components/Integrations/IntegrationStore"));
const ApiKeys = React.lazy(() => import("./components/Integrations/ApiKeys"));
const StatutoryExports = React.lazy(() => import("./components/Payroll/StatutoryExports"));
const OvertimeRequestNew = React.lazy(() => import("./components/Overtime/OvertimeRequestNew"));
const ManagerOvertimeRequestsNew = React.lazy(() => import("./components/Overtime/ManagerOvertimeRequestsNew"));
const SalaryRevisions = React.lazy(() => import("./components/Payroll/SalaryRevisions"));
const ManagerLeaveRequestsNew = React.lazy(() => import("./components/Leave/ManagerLeaveRequestsNew"));
const LeaveRequestsNew = React.lazy(() => import("./components/Leave/LeaveRequestsNew"));
const TeamLeaveBalances = React.lazy(() => import("./components/Leave/TeamLeaveBalances"));
const EmployeeListNew = React.lazy(() => import("./components/Employee/EmployeeListNew"));
const ReimbursementListNew = React.lazy(() => import("./components/Reimbursment/ReimbursementListNew"));
const ManagerReimbursementApprovalsNew = React.lazy(() =>
  import("./components/Reimbursment/ManagerReimbursementApprovalsNew")
);
const TrainingCatalog = React.lazy(() => import("./components/Training/TrainingCatalog"));
const NotificationPreferences = React.lazy(() => import("./components/Notification/NotificationPreferences"));
const LeaveAdvanced = React.lazy(() => import("./components/Leave/LeaveAdvanced"));
const MyReviews = React.lazy(() => import("./components/Performance/MyReviews"));
const OfferApprovals = React.lazy(() => import("./components/Recruitment/OfferApprovals"));
const RecruitmentAnalytics = React.lazy(() => import("./components/Recruitment/RecruitmentAnalytics"));
const TalentPool = React.lazy(() => import("./components/Recruitment/TalentPool"));
const HelpdeskAdmin = React.lazy(() => import("./components/Helpdesk/HelpdeskAdmin"));
const ScheduledReports = React.lazy(() => import("./components/Reports/ScheduledReports"));
const WeeklyAttendanceReport = React.lazy(() => import("./components/Reports/WeeklyAttendanceReport"));
const OutOfOfficeSettings = React.lazy(() => import("./components/Messages/OutOfOfficeSettings"));
const PreJoiningPortal = React.lazy(() => import("./components/Onboarding/PreJoiningPortal"));

// Project Management module
const ProjectsList = React.lazy(() => import("./components/Projects/ProjectsList"));
const ProjectDetail = React.lazy(() => import("./components/Projects/ProjectDetail"));
const NewProject = React.lazy(() => import("./components/Projects/NewProject"));
const TeamsPage = React.lazy(() => import("./components/Projects/TeamsPage"));
const DocsPage = React.lazy(() => import("./components/Docs/DocsPage"));
// Performance & payroll admin views added during Taiga fixes
const ManagerFeedbackList = React.lazy(() => import("./components/Performance/ManagerFeedbackList"));
const EmployeeManagerFeedback = React.lazy(() => import("./components/Performance/EmployeeManagerFeedback"));
const SelfAssessmentList = React.lazy(() => import("./components/Performance/SelfAssessmentList"));
const MySelfAssessments = React.lazy(() => import("./components/Performance/MySelfAssessments"));
const TeamSelfAssessments = React.lazy(() => import("./components/Performance/TeamSelfAssessments"));
const ReviewForm = React.lazy(() => import("./components/Performance/ReviewForm"));
const DeclarationsAdmin = React.lazy(() => import("./components/Payroll/DeclarationsAdmin"));
const FBPAdmin = React.lazy(() => import("./components/Payroll/FBPAdmin"));
const ModuleSettings = React.lazy(() => import("./components/Settings/ModuleSettings"));

class ChunkErrorBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    const msg = String(error?.message || error || "");
    const isChunk =
      error?.name === "ChunkLoadError" ||
      /Loading chunk|ChunkLoadError|Failed to fetch dynamically imported module/i.test(msg);
    if (isChunk && !sessionStorage.getItem("chunk_reload")) {
      sessionStorage.setItem("chunk_reload", "1");
      window.location.reload();
    }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, textAlign: "center" }}>
          <p>Failed to load this page. Refreshing…</p>
          <button type="button" onClick={() => window.location.reload()}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const withSuspense = (Component) => (
  <ChunkErrorBoundary>
    <Suspense fallback={<div style={{ padding: 40, textAlign: "center" }}>Loading...</div>}>
      <Component />
    </Suspense>
  </ChunkErrorBoundary>
);

function App() {
  React.useEffect(() => {
    // Allow a future auto-reload if another stale chunk appears later.
    sessionStorage.removeItem("chunk_reload");
  }, []);

  return (
    <Router>
      <div className="App">
        {/* Previously had <main className="App-main"> here, but AppShell renders
            its own <main>. Having two <main> elements nested violates WCAG
            (landmark-main-is-top-level, landmark-no-duplicate-main). Use a plain
            container so AppShell's <main> is the single top-level landmark. */}
        <div className="App-main">
          <Routes>
            <Route path="/" element={<LandingPage/>} />


            <Route path="/holidays" element={<PrivateRoute element={HolidaysList} />} />
            <Route path="/create-employee" element={<PrivateRoute element={() => <RoleGuard access="critical"><CreateEmployee /></RoleGuard>} />} />
            <Route path="/EmployeeList" element={<PrivateRoute element={() => <RoleGuard access="critical"><EmployeeList /></RoleGuard>} />} />
            <Route path="/EmployeeDetail" element={<PrivateRoute element={EmployeeDetail} />} />
            <Route path="/ArchivedEmployeeList" element={<PrivateRoute element={() => <RoleGuard access="critical"><ArchivedEmployeeList /></RoleGuard>} />} />
            <Route path="/HolidayForm" element={<PrivateRoute element={HolidayForm} />} />
            <Route path="/ApplyForLeave" element={<PrivateRoute element={ApplyForLeave} />} />
            <Route path="/LeaveRequests" element={<PrivateRoute element={LeaveRequests} />} />
            <Route path="/AttendancePortal" element={<PrivateRoute element={AttendancePortal} />} />
            <Route path="/SalarySlipForm" element={<PrivateRoute element={SalarySlipForm} />} />
            <Route path="/GetMyAttendance" element={<PrivateRoute element={GetMyAttendance} />} />
            <Route path="/AdminAttendanceLookup" element={<PrivateRoute element={() => <RoleGuard access="critical"><AdminAttendanceLookup /></RoleGuard>} />} />
            <Route path="/attendance/team-report" element={<PrivateRoute element={() => <RoleGuard access="critical"><AdminAttendanceLookup /></RoleGuard>} />} />
            <Route path="/InventoryForm" element={<PrivateRoute element={InventoryForm} />} />
            <Route path="/InventoryList" element={<PrivateRoute element={() => <RoleGuard access="critical"><InventoryList /></RoleGuard>} />} />
            <Route path="/ReimbursementForm" element={<PrivateRoute element={ReimbursementForm} />} />
            <Route path="/ReimbursementList" element={<PrivateRoute element={ReimbursementList} />} />
            <Route path="/HolidaysListForEmployees" element={<PrivateRoute element={HolidaysListForEmployees} />} />
            <Route path="/MySalarySlip" element={<PrivateRoute element={MySalarySlip} />} />
            <Route path="/MyInventories" element={<PrivateRoute element={MyInventories} />} />
            <Route path="/UserProfile" element={<PrivateRoute element={UserProfile} />} />
            <Route path="/AssignInventoryToEmployee" element={<PrivateRoute element={() => <RoleGuard access="critical"><AssignInventoryToEmployee /></RoleGuard>} />} />
            <Route path="/InventorySearch" element={<PrivateRoute element={InventorySearch} />} />
            <Route path="/EmployeeDashboard" element={<PrivateRoute element={EmployeeDashboard} />} />
            <Route path="/NotificationForm" element={<PrivateRoute element={NotificationForm} />} />
            <Route path="/ListByRole" element={<PrivateRoute element={ManagerList} />} />
            <Route path="/ManagerFeedbackForm" element={<PrivateRoute element={() => <RoleGuard access="approver"><ManagerFeedbackForm /></RoleGuard>} />} />
            <Route path="/manager-feedback" element={<PrivateRoute element={() => <RoleGuard access="approver">{withSuspense(ManagerFeedbackList)}</RoleGuard>} />} />
            <Route path="/employee-feedback" element={<PrivateRoute element={() => withSuspense(EmployeeManagerFeedback)} />} />
            <Route path="/self-assessments" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(SelfAssessmentList)}</RoleGuard>} />} />
            <Route path="/team-self-assessments" element={<PrivateRoute element={() => <RoleGuard access="approver">{withSuspense(TeamSelfAssessments)}</RoleGuard>} />} />
            <Route path="/my-self-assessments" element={<PrivateRoute element={() => withSuspense(MySelfAssessments)} />} />
            <Route path="/reviews/:id" element={<PrivateRoute element={() => withSuspense(ReviewForm)} />} />
            <Route path="/SelfAssessmentForm" element={<PrivateRoute element={SelfAssessmentForm} />} />
            <Route path="/MyReimbursements" element={<PrivateRoute element={MyReimbursements} />} />
            <Route path="/ManagerleaveRequest" element={<PrivateRoute element={() => <RoleGuard access="approver">{React.createElement(ManagerleaveRequest)}</RoleGuard>} />} />
            <Route path="/contactdetail" element={<PrivateRoute element={() => <RoleGuard access="critical">{React.createElement(contactdetail)}</RoleGuard>} />} />
            <Route path="/CalendarView" element={<PrivateRoute element={CalendarView} />} />
            <Route path="/SendMessage" element={<PrivateRoute element={SendMessage} />} />
            <Route path="/MyMessages" element={<PrivateRoute element={MyMessages} />} />
            <Route path="/my-messages" element={<PrivateRoute element={MyMessages} />} />
            <Route path="/MySentMessages" element={<PrivateRoute element={MySentMessages} />} />
            <Route path="/Whiteboard" element={<PrivateRoute element={Whiteboard} />} />
            <Route path="/chatboard" element={<PrivateRoute element={chatboard} />} />
            <Route path="/groupchatboard" element={<PrivateRoute element={groupchatboard} />} />
            <Route path="/timesheet" element={<PrivateRoute element={timesheet} />} />
            <Route path="/timesheetlist" element={<PrivateRoute element={timesheetlist} />} />
            <Route path="/timesheetacess" element={<PrivateRoute element={() => <RoleGuard access="critical">{React.createElement(timesheetacess)}</RoleGuard>} />} />
            <Route path="/ExpenseDashboard" element={<PrivateRoute element={() => <RoleGuard access="critical"><ExpenseDashboard /></RoleGuard>} />} />
            <Route path="/ResetPassword" element={<PrivateRoute element={ResetPassword} />} />
            <Route path="/ReimbursementReport" element={<PrivateRoute element={ReimbursementReport} />} />
            <Route path="/VideoUpload" element={<PrivateRoute element={VideoUpload} />} />
            <Route path="/OvertimeRequest" element={<PrivateRoute element={OvertimeRequest} />} />
            <Route path="/ManagerOvertimeRequests" element={<PrivateRoute element={() => <RoleGuard access="approver"><ManagerOvertimeRequests /></RoleGuard>} />} />
            <Route path="/ManagerAttendanceApprovals" element={<PrivateRoute element={() => <RoleGuard access="approver"><ManagerAttendanceApprovals /></RoleGuard>} />} />
            <Route path="/AttendanceRegularization" element={<PrivateRoute element={AttendanceRegularization} />} />



            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            {/* Public reset-password route — matches the link in reset emails
                ("/reset-password?token=..."). Must NOT be behind PrivateRoute or a
                logged-out user clicking the email link lands on a blank/redirect page. */}
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Payroll */}
            <Route path="/payroll/config" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(PayrollConfigPage)}</RoleGuard>} />} />
            <Route path="/payroll/loans" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(LoanManagement)}</RoleGuard>} />} />
            <Route path="/payroll/run" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(PayrollRun)}</RoleGuard>} />} />
            <Route path="/payroll/my-payslips" element={<PrivateRoute element={() => withSuspense(MyPayslips)} />} />

            {/* Onboarding */}
            <Route path="/onboarding" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(OnboardingList)}</RoleGuard>} />} />
            <Route path="/onboarding/:id" element={<PrivateRoute element={() => withSuspense(OnboardingDetail)} />} />

            {/* Offboarding */}
            <Route path="/offboarding" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(OffboardingList)}</RoleGuard>} />} />
            <Route path="/offboarding/:id" element={<PrivateRoute element={() => withSuspense(OffboardingDetail)} />} />

            {/* Reports & Analytics */}
            <Route path="/reports" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(ReportsDashboard)}</RoleGuard>} />} />

            {/* Leave Types Admin */}
            <Route path="/leave/types" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(LeaveTypesConfig)}</RoleGuard>} />} />

            {/* Recruitment */}
            <Route path="/recruitment/jobs" element={<PrivateRoute element={() => withSuspense(JobsList)} />} />
            <Route path="/recruitment/jobs/:id" element={<PrivateRoute element={() => withSuspense(JobDetail)} />} />
            <Route path="/recruitment/jobs/:jobId/pipeline" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(CandidatePipeline)}</RoleGuard>} />} />

            {/* Announcements, Policies, Goals */}
            <Route path="/announcements" element={<PrivateRoute element={() => withSuspense(AnnouncementsList)} />} />
            <Route path="/policies" element={<PrivateRoute element={() => withSuspense(PoliciesList)} />} />
            <Route path="/goals" element={<PrivateRoute element={() => withSuspense(GoalsList)} />} />

            {/* Self-Service */}
            <Route path="/directory" element={<PrivateRoute element={() => withSuspense(TeamDirectory)} />} />
            <Route path="/org-chart" element={<PrivateRoute element={() => withSuspense(OrgChart)} />} />
            <Route path="/me" element={<PrivateRoute element={() => withSuspense(MyProfileEdit)} />} />
            <Route path="/my-documents" element={<PrivateRoute element={() => withSuspense(DocumentVault)} />} />
            <Route path="/letters" element={<PrivateRoute element={() => withSuspense(Letters)} />} />

            {/* Payroll deep */}
            <Route path="/payroll/declaration" element={<PrivateRoute element={() => withSuspense(InvestmentDeclaration)} />} />
            <Route path="/payroll/declarations-admin" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(DeclarationsAdmin)}</RoleGuard>} />} />
            <Route path="/payroll/fbp" element={<PrivateRoute element={() => withSuspense(FlexibleBenefits)} />} />
            <Route path="/payroll/fbp-admin" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(FBPAdmin)}</RoleGuard>} />} />
            <Route path="/payroll/batch" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(BatchPayroll)}</RoleGuard>} />} />

            {/* Attendance advanced */}
            <Route path="/attendance/shifts" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(ShiftsConfig)}</RoleGuard>} />} />
            <Route path="/attendance/geo-fences" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(GeoFencesConfig)}</RoleGuard>} />} />
            <Route path="/attendance/office-ips" element={<PrivateRoute element={() => <RoleGuard allowed={["admin"]}>{withSuspense(OfficeIpsConfig)}</RoleGuard>} />} />
            <Route path="/attendance/team-calendar" element={<PrivateRoute element={() => withSuspense(TeamLeaveCalendar)} />} />
            <Route path="/leave/balance" element={<PrivateRoute element={() => withSuspense(MyLeaveBalance)} />} />

            {/* Performance */}
            <Route path="/kudos" element={<PrivateRoute element={() => withSuspense(KudosWall)} />} />
            <Route path="/check-ins" element={<PrivateRoute element={() => withSuspense(CheckIns)} />} />
            <Route path="/nine-box" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(NineBoxGrid)}</RoleGuard>} />} />
            <Route path="/pips" element={<PrivateRoute element={() => <RoleGuard allowed={["admin", "hr", "manager", "employee"]}>{withSuspense(PIPList)}</RoleGuard>} />} />
            <Route path="/review-cycles" element={<PrivateRoute element={() => <RoleGuard allowed={["admin", "hr", "manager", "employee"]}>{withSuspense(ReviewCycles)}</RoleGuard>} />} />

            {/* Learning & Development */}
            <Route path="/training" element={<PrivateRoute element={() => withSuspense(TrainingCatalog)} />} />
            <Route path="/learning" element={<PrivateRoute element={() => withSuspense(TrainingCatalog)} />} />

            {/* Notification preferences + Leave advanced */}
            <Route path="/settings/notifications" element={<PrivateRoute element={() => withSuspense(NotificationPreferences)} />} />
            <Route path="/leave/advanced" element={<PrivateRoute element={() => withSuspense(LeaveAdvanced)} />} />
            <Route path="/my-reviews" element={<PrivateRoute element={() => <RoleGuard access="approver">{withSuspense(MyReviews)}</RoleGuard>} />} />
            <Route path="/approvals/recruitment" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(OfferApprovals)}</RoleGuard>} />} />
            <Route path="/recruitment/analytics" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(RecruitmentAnalytics)}</RoleGuard>} />} />
            <Route path="/recruitment/talent-pool" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(TalentPool)}</RoleGuard>} />} />
            <Route path="/helpdesk/admin" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(HelpdeskAdmin)}</RoleGuard>} />} />
            <Route path="/reports/scheduled" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(ScheduledReports)}</RoleGuard>} />} />
            <Route path="/reports/attendance-weekly" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(WeeklyAttendanceReport)}</RoleGuard>} />} />
            <Route path="/messages/out-of-office" element={<PrivateRoute element={() => withSuspense(OutOfOfficeSettings)} />} />
            {/* Public pre-joining (no auth) */}
            <Route path="/pre-joining/:token" element={withSuspense(PreJoiningPortal)} />

            {/* Recruitment - Public */}
            <Route path="/careers" element={withSuspense(CareerPage)} />
            <Route path="/sign/offer/:token" element={withSuspense(OfferSignPage)} />

            {/* Recruitment - Authenticated */}
            <Route path="/referrals" element={<PrivateRoute element={() => withSuspense(Referrals)} />} />

            {/* Travel & Expenses */}
            <Route path="/travel" element={<PrivateRoute element={() => withSuspense(TravelRequests)} />} />
            <Route path="/travel/approvals" element={<PrivateRoute element={() => <RoleGuard access="approver">{withSuspense(TravelApprovals)}</RoleGuard>} />} />

            {/* Engagement */}
            <Route path="/surveys" element={<PrivateRoute element={() => withSuspense(SurveysList)} />} />
            <Route path="/surveys/builder" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(SurveyBuilder)}</RoleGuard>} />} />

            {/* Helpdesk */}
            <Route path="/helpdesk" element={<PrivateRoute element={() => withSuspense(TicketsList)} />} />
            <Route path="/helpdesk/:id" element={<PrivateRoute element={() => withSuspense(TicketDetail)} />} />
            <Route path="/kb" element={<PrivateRoute element={() => withSuspense(KnowledgeBase)} />} />

            {/* Analytics deep */}
            <Route path="/reports/builder" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(CustomReportBuilder)}</RoleGuard>} />} />
            <Route path="/reports/attrition-risk" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(AttritionRisk)}</RoleGuard>} />} />
            <Route path="/reports/dei" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(DEIDashboard)}</RoleGuard>} />} />

            {/* Workflows */}
            <Route path="/workflows" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(WorkflowsList)}</RoleGuard>} />} />

            {/* Security */}
            <Route path="/security/2fa" element={<PrivateRoute element={() => withSuspense(TwoFactorSetup)} />} />
            <Route path="/security/sessions" element={<PrivateRoute element={() => withSuspense(SessionsList)} />} />
            <Route path="/security/audit-log" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(AuditLog)}</RoleGuard>} />} />

            {/* SSO */}
            <Route path="/sso-callback" element={withSuspense(SSOCallback)} />

            {/* Integrations */}
            <Route path="/integrations" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(IntegrationStore)}</RoleGuard>} />} />
            <Route path="/integrations/webhooks" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(IntegrationsList)}</RoleGuard>} />} />
            <Route path="/integrations/api-keys" element={<PrivateRoute element={() => <RoleGuard allowed={["admin"]}>{withSuspense(ApiKeys)}</RoleGuard>} />} />
            <Route path="/settings/modules" element={<PrivateRoute element={() => <RoleGuard allowed={["admin"]}>{withSuspense(ModuleSettings)}</RoleGuard>} />} />

            {/* Statutory + OT rebuilt */}
            <Route path="/payroll/statutory" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(StatutoryExports)}</RoleGuard>} />} />
            <Route path="/overtime" element={<PrivateRoute element={() => withSuspense(OvertimeRequestNew)} />} />
            <Route path="/overtime/approvals" element={<PrivateRoute element={() => <RoleGuard access="approver">{withSuspense(ManagerOvertimeRequestsNew)}</RoleGuard>} />} />
            <Route
              path="/reimbursements/approvals"
              element={
                <PrivateRoute
                  element={() => (
                    <RoleGuard access="approver">
                      {withSuspense(ManagerReimbursementApprovalsNew)}
                    </RoleGuard>
                  )}
                />
              }
            />

            {/* Retrofitted legacy pages — new versions */}
            <Route path="/payroll/revisions" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(SalaryRevisions)}</RoleGuard>} />} />
            <Route path="/leave/approvals" element={<PrivateRoute element={() => <RoleGuard access="approver">{withSuspense(ManagerLeaveRequestsNew)}</RoleGuard>} />} />
            <Route path="/leave/team-balances" element={<PrivateRoute element={() => <RoleGuard access="approver">{withSuspense(TeamLeaveBalances)}</RoleGuard>} />} />
            <Route path="/leave/my" element={<PrivateRoute element={() => withSuspense(LeaveRequestsNew)} />} />
            <Route path="/employees" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(EmployeeListNew)}</RoleGuard>} />} />
            <Route path="/reimbursements" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(ReimbursementListNew)}</RoleGuard>} />} />

            {/* Aliases for redesigned pages */}
            <Route path="/Holiday" element={<PrivateRoute element={HolidaysList} />} />
            <Route path="/submit-reimbursement" element={<PrivateRoute element={ReimbursementForm} />} />
            <Route path="/my-reimbursements" element={<PrivateRoute element={MyReimbursements} />} />
            <Route path="/submit-timesheet" element={<PrivateRoute element={timesheet} />} />
            <Route path="/viewAllTimesheets" element={<PrivateRoute element={timesheetlist} />} />
            <Route path="/inventorydetail" element={<PrivateRoute element={InventorySearch} />} />
            <Route path="/inventoryform" element={<PrivateRoute element={InventoryForm} />} />
            <Route path="/my-sent-messages" element={<PrivateRoute element={MySentMessages} />} />
            <Route path="/performance" element={<PrivateRoute element={() => withSuspense(KudosWall)} />} />

            {/* Project Management */}
            <Route path="/projects" element={<PrivateRoute element={() => withSuspense(ProjectsList)} />} />
            <Route path="/projects/new" element={<PrivateRoute element={() => <RoleGuard access="critical">{withSuspense(NewProject)}</RoleGuard>} />} />
            <Route path="/projects/teams" element={<PrivateRoute element={() => withSuspense(TeamsPage)} />} />
            <Route path="/projects/:id" element={<PrivateRoute element={() => withSuspense(ProjectDetail)} />} />
            <Route path="/docs" element={<PrivateRoute element={() => withSuspense(DocsPage)} />} />

            {/* Catch-all: never render a blank page for an unknown route (QA #510/#513) */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
